module.exports = __webpack_public_path__ + "img/ejaf-erpimg-8.0663d969.png";